// extracted by mini-css-extract-plugin
export var breakoutBox = "styles-module--breakoutBox--5e55d";
export var breakoutContainer = "styles-module--breakoutContainer--7a762";
export var content = "styles-module--content--4b28e";
export var green = "styles-module--green--747a5";
export var pink = "styles-module--pink--62334";
export var textContainer = "styles-module--textContainer--f9dd1";
export var title = "styles-module--title--2b604";
export var visible = "styles-module--visible--e7778";
export var white = "styles-module--white--1a8b2";